import { AppRoutes } from "./Routes";
import { SocketProvider } from "./state/SocketContext";

export default function App() {
  return (
    <SocketProvider>
      <AppRoutes />
    </SocketProvider>
  );
}
